import { FEATURE_FLAGS } from '@constants/feature';
import UserPermissionTypes from '@constants/permissions';

import { getPermissionCatalogEntry } from './permissionCatalog';

export type CreateRoleFeatureContext = {
  orgFeatureFlags?: string[];
  isAttendanceFeatureEnabled?: boolean;
};

const MODULE_FEATURE_FLAGS: Partial<Record<string, string>> = {
  Events: FEATURE_FLAGS.EVENTS,
  Forms: FEATURE_FLAGS.FORMS,
  'Lead management': FEATURE_FLAGS.LEAD_MANAGEMENT,
  'Expense tracker': FEATURE_FLAGS.EXPENSE_TRACKER,
  Integrations: FEATURE_FLAGS.API_INTEGRATIONS
};

// Individual permissions gated by a flag within an otherwise ungated module
const PERMISSION_FEATURE_FLAGS: Partial<Record<string, string>> = {
  [UserPermissionTypes.AUDIT_LOG_VIEW]: FEATURE_FLAGS.AUDIT_LOG_MERCHANT_ACCESS,
  [UserPermissionTypes.GROUP_MEMBER_TAG_ASSIGN]: FEATURE_FLAGS.MEMBER_TAGGING
};

export const isPermissionModuleFeatureEnabled = (
  module: string,
  context: CreateRoleFeatureContext
): boolean => {
  if (module === 'Attendance') {
    return Boolean(context.isAttendanceFeatureEnabled);
  }

  const featureFlag = MODULE_FEATURE_FLAGS[module];
  if (!featureFlag) return true;

  return context.orgFeatureFlags?.includes(featureFlag) ?? false;
};

export const isPermissionSlugFeatureEnabled = (
  slug: string,
  context: CreateRoleFeatureContext
): boolean => {
  const featureFlag = PERMISSION_FEATURE_FLAGS[slug];
  if (featureFlag && !context.orgFeatureFlags?.includes(featureFlag)) {
    return false;
  }

  const { module } = getPermissionCatalogEntry(slug);
  return isPermissionModuleFeatureEnabled(module, context);
};

export const filterDisplayablePermissionSlugs = (
  slugs: string[],
  context: CreateRoleFeatureContext
): string[] =>
  slugs.filter((slug) => isPermissionSlugFeatureEnabled(slug, context));
